import { Navigate } from "react-router-dom";
import { useMe } from "@/lib/me";
import ClubSetupPending from "./club-setup-pending";

export default function OnboardingGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const { user, club, isLoading } = useMe();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-neutral-50">
        <div className="w-6 h-6 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // MANAGER with an unconfigured club must finish onboarding before seeing
  // anything in the dashboard.
  if (user?.role === "MANAGER" && club && !club.setupComplete) {
    return <Navigate to="/onboarding" replace />;
  }

  // STAFF can't run onboarding themselves — if their club isn't set up yet
  // (or they have no club), show a waiting screen instead of a broken dashboard.
  if (user?.role === "STAFF" && (!club || !club.setupComplete)) {
    return <ClubSetupPending />;
  }

  return <>{children}</>;
}
